export const FETCH_CONFIGURATION_SETTINGS_PILL = 'FETCH_CONFIGURATION_SETTINGS_PILL';
export const FETCH_CONFIGURATION_SETTINGS_PILL_SUCCESS = 'FETCH_CONFIGURATION_SETTINGS_PILL_SUCCESS';
export const FETCH_CONFIGURATION_SETTINGS_PILL_FAILURE = 'FETCH_CONFIGURATION_SETTINGS_PILL_FAILURE';
export const FETCH_CONFIGURATION_SETTINGS_FOR_EXPORT = 'FETCH_CONFIGURATION_SETTINGS_FOR_EXPORT';
export const FETCH_CONFIGURATION_SETTINGS_FOR_EXPORT_FAILURE = 'FETCH_CONFIGURATION_SETTINGS_FOR_EXPORT_FAILURE';
